import Api from '@/services/Api';

export default {
  createMeal(foods: object[], meal: object) {
    return Api().post('meals/create', {foods, meal}, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  updateMeal(meal: object) {
    return Api().post('meals/update', {meal}, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getMealDetails(mealid: string) {
    return Api().get('meals/details/' + mealid, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getMeals() {
    return Api().get('meals/', {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getAllMeals() {
    return Api().get('meals/all', {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getMealFoods(id: string) {
    return Api().get(`meals/details/${id}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  deleteMeal(id: string) {
    return Api().delete(`meals/delete/${id}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  exportMeal(date: string, id: string) {
    return Api().post(`meals/set_date/${id}`, { date }, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getGraphicDataBySquid(squid: string) {
    return Api().get(`meals/squid/${squid}`, {
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    });
  },
  getGraphic(id: string, author: string) {
    return Api().get(`meals/graphic/${author}/${id}`, {
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    });
  },
  getGraphics(ids: string) {
    return Api().get(`meals/graphics/${ids}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getMealName(id: string) {
    return Api().get(`meals/graphic/name/${id}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getMealVersions(main: string) {
    return Api().get(`meals/version?main=${main}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getMealStreams() {
    return Api().get('meals/streams', {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  }
};
